import Vue from 'vue'
import App from './App.vue'


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import store from './store'



Vue.use(ElementUI);

// -- 多语言 -- start
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const LangInfo = JSON.parse(localStorage.getItem('lang'))

const i18n = new VueI18n({
	locale: LangInfo == undefined ||
		LangInfo == "" ||
		LangInfo == null ?
		"EN" : LangInfo.abbreviation,
	messages: {
		CN: require("./assets/lang/CN.js"),
		EN: require("./assets/lang/EN.js"),
		JPN: require("./assets/lang/JPN.js"),
		Kr: require("./assets/lang/Kr.js"),
		TC: require("./assets/lang/TC.js"),
	}
});
Vue.prototype._i18n = i18n

// console.log("测试", Vue);
//return false;
// -- 多语言 -- end


import VueRouter from 'vue-router'
Vue.use(VueRouter)


import index1 from './view/index.vue'
const routes = [

	{
		path: '/',
		component: index1,
		meta: {
			title: 'Home'
		}
	},
]



// 实例化路由

const router = new VueRouter({
	mode: 'history',
	routes // （缩写）相当于 routes: routes

})

// 路由跳转之前执行
router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	next()
})






Vue.config.productionTip = false

new Vue({
	//el:"#app",
	// components:{
	//   App  //在 index.html页面不使用这个组件，就会返回 We're sorry but demo3 doesn't work properly without JavaScript enabled. Please enable it to continue.
	//  },
	router, // 挂载路由
	store,		// 挂载到 vue实例上
	//_i18n : i18n,
	mounted() {
		document.dispatchEvent(new Event('render-event'))
	},
	render: h => h(App),
}).$mount('#app')
